import type { Common } from "@beautypie/segment"
// eslint-disable-next-line import/no-cycle
import { getPageName } from "data/tracking/segment/helpers"
import type { CountryType } from "lib/apollo/types"
import type { DeepRequired } from "tracking"
import { isBrowser } from "utils/isBrowser"

type Page = DeepRequired<Common, ["context", "page"]>["context"]["page"]

export const parsePageDetails = (locale: CountryType): Page => {
  let name: string | undefined
  let path: string | undefined

  if (isBrowser()) {
    path = window.location.pathname
    name = getPageName(path, path, locale)
  }

  return {
    title: document.title,
    url: window.location.href,
    referrer: document.referrer !== "" ? document.referrer : undefined,
    path,
    search: window.location.search !== "" ? window.location.search : undefined,
    name,
  }
}
